var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreenOff = function SvgFullscreenOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.626 29.735h10.519L4.714 41.165l2.122 2.121 11.43-11.43v10.519h3v-15.64H5.626zm37.66-22.9-2.121-2.121-11.431 11.431V5.625h-3v15.641h15.641v-3H31.856z"
  })))));
};
export default SvgFullscreenOff;